import React, { useMemo } from 'react'
import { convertPointsToPrice } from 'constants/merchandise'
import qs from 'qs'
import { useAppSelector } from 'hooks/reduxHooks'
import FormatLoyaltyPoints from 'loyalty/components/Formatters/FormatLoyaltyPoints'
import { selectLoggedIn } from 'selectors/accountSelectors'
import MerchandiseOfferCarousel from './MerchandiseOfferCarousel'

const MAX_POINTS = 25000000
const MIN_POINTS = 2500

interface Props {
  filters?: App.MerchandiseFilters
  trackingPageName: string
}

function MerchandisePointsCarousel({ filters, trackingPageName }: Props) {
  const points = useAppSelector(state => state.loyalty.account.data?.points ?? 0)
  const isLoggedIn = useAppSelector(state => selectLoggedIn(state))

  const shouldShowCarousel = isLoggedIn && points >= MIN_POINTS

  const pointsFilter = useMemo((): App.MerchandiseFilters | undefined => {
    if (!shouldShowCarousel) return

    const minPoints = Math.max(1, Math.floor(points * 0.5)) // 50% less
    const maxPoints = Math.floor(points * 1.5) // 50% more

    return {
      ...(filters ?? {}),
      price: {
        min: convertPointsToPrice(Math.max(MIN_POINTS, minPoints)),
        max: convertPointsToPrice(Math.min(MAX_POINTS, maxPoints)),
      },
      sortBy: 'priceAsc',
    }
  }, [points, shouldShowCarousel, filters])

  const pointsUrl = useMemo(() => {
    if (!shouldShowCarousel || !pointsFilter) return

    return `/search/shop?${qs.stringify({
      ...(filters ?? {}),
      'price.min': pointsFilter?.price?.min,
      'price.max': pointsFilter?.price?.max,
      sortBy: 'priceAsc',
    })}`
  }, [pointsFilter, shouldShowCarousel, filters])

  if (!shouldShowCarousel) {
    return null
  }

  return (
    <MerchandiseOfferCarousel
      title={<>Shop with your <em><FormatLoyaltyPoints points={points} abbreviated /></em></>}
      filters={pointsFilter}
      viewAllTo={pointsUrl}
      trackingListName="Shop with your points"
      trackingPageName={trackingPageName}
    />
  )
}

export default MerchandisePointsCarousel
